import React, { FC } from "react";
import { Link } from "react-router-dom";
import { IPaginationQueryData, useNavigateQueryLinkBuilder } from "utils/url";
import style from "./style.scss";
import { getEndIndex, getNextStartingIndex, getPrevStartingIndex } from "./utils";

export interface QueryStringPagingProps {
    currentIndex: number;
    itemsPerPage: number;
    totalItems: number;
    hideLinks?: boolean;
}

const QueryStringPagingInner: FC<QueryStringPagingProps> = (props: QueryStringPagingProps) => {
    const { currentIndex, itemsPerPage, totalItems, hideLinks } = props;
    const nextIndex = getNextStartingIndex(currentIndex, itemsPerPage);
    const prevIndex = getPrevStartingIndex(currentIndex, itemsPerPage);

    const navigatePageLink = useNavigateQueryLinkBuilder<IPaginationQueryData>();

    function renderPrevLink(prevIndex: number) {
        if (prevIndex >= 0) {
            const prevLink = navigatePageLink({
                fromIndex: prevIndex
            });
            return <Link to={prevLink}>Prev Page</Link>;
        } else {
            return <span className={style.disabled}>Prev Page</span>;
        }
    }

    function renderNextLink(nextIndex: number) {
        if (nextIndex > totalItems) {
            return <span className={style.disabled}>Next Page</span>;
        } else {
            const nextLink = navigatePageLink({
                fromIndex: nextIndex
            });
            return <Link to={nextLink}>Next Page</Link>;
        }
    }

    return (
        <div className={style.wrap}>
            <div className={style.linkswrap}>
                {
                    !hideLinks &&
                    <div className={style.links}>
                        {renderPrevLink(prevIndex)} | {renderNextLink(nextIndex)}
                    </div>
                }
                <div className={style.status}>
                    <p>Showing {currentIndex + 1} - {getEndIndex(currentIndex, itemsPerPage, totalItems)} of {totalItems}</p>
                </div>
            </div>
        </div>
    );
};

export const QueryStringPaging = React.memo(QueryStringPagingInner);
